module.exports = __webpack_public_path__ + "img/lr.90f2b813.svg";